import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';

export const Heading = styled(HeadingBase)``;

export const HeaderWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[3]};
  padding-bottom: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  padding-top: 12px;
`;
